module.exports = __webpack_public_path__ + "media/images/emblems/Valeyres-sous-Rances-coat_of_arms-e3787a00d483e63f1fddfff504585c49.svg";